// extracted by css-extract-rspack-plugin
export default {"ListItem_0":"PullRequestItem-module__ListItem_0__MeQYV"};